'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import { Button } from '@udemy-v2/react-core-components';
import { Language, useI18n } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import styles from './course-caption-details.module.scss';
import { CourseCaption } from '@udemy-v2/browse-course';
import classNames from 'classnames';
export interface CourseCaptionDetailsProps {
  captionedLanguages: CourseCaption[];
  isExpanded?: boolean;
  onExpandChange?: (expanded: boolean) => void;
}

/**
 * CourseCaptionDetails displays the available caption languages for a course.
 * It has different implementations for desktop and mobile views.
 */
export const CourseCaptionDetails: React.FC<CourseCaptionDetailsProps> = t0 => {
  const $ = _c(25);
  const {
    captionedLanguages,
    isExpanded: t1,
    onExpandChange
  } = t0;
  const isExpanded = t1 === undefined ? false : t1;
  const {
    gettext,
    ninterpolate
  } = useI18n();
  const [isLocalExpanded, setIsLocalExpanded] = useState(isExpanded);
  let t2;
  let t3;
  if ($[0] !== isExpanded) {
    t2 = () => {
      setIsLocalExpanded(isExpanded);
    };
    t3 = [isExpanded];
    $[0] = isExpanded;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== isLocalExpanded || $[4] !== onExpandChange) {
    t4 = () => {
      const newExpandedState = !isLocalExpanded;
      setIsLocalExpanded(newExpandedState);
      onExpandChange?.(newExpandedState);
    };
    $[3] = isLocalExpanded;
    $[4] = onExpandChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleExpandClick = t4;
  let t5;
  if ($[6] !== gettext) {
    t5 = (language, index, totalCount) => <span key={language.locale} className={classNames(styles["language-display"], "ud-text-sm", "ud-text-subdued")}><Language locale={language.locale} />{language.isAutoGenerated && (index < totalCount - 1 ? gettext(" [Auto],") : gettext(" [Auto]"))}</span>;
    $[6] = gettext;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const renderLanguage = t5;
  if (!captionedLanguages.length) {
    return null;
  }
  let t6;
  if ($[8] !== captionedLanguages || $[9] !== gettext || $[10] !== handleExpandClick || $[11] !== isLocalExpanded || $[12] !== ninterpolate || $[13] !== renderLanguage) {
    const visibleLanguages = captionedLanguages.slice(0, 2);
    const extraLanguages = captionedLanguages.slice(2);
    let t7;
    if ($[15] !== isLocalExpanded) {
      t7 = classNames("ud-text-sm", styles.captions, {
        [styles.expanded]: isLocalExpanded
      });
      $[15] = isLocalExpanded;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== gettext) {
      t8 = gettext("Closed Captions");
      $[17] = gettext;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== t8) {
      t9 = <Icon glyph="subtitles" size="xsmall" color="subdued-inverted" label={false} className={styles["subtitles-icon"]} role="img" aria-label={t8} aria-hidden={false} />;
      $[19] = t8;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    const t10 = visibleLanguages.map((language_0, index_0) => renderLanguage(language_0, index_0, visibleLanguages.length + 1));
    const t11 = extraLanguages.length > 0 && !isLocalExpanded && <Button udStyle="link" size="medium" onClick={handleExpandClick} className={styles["more-button"]} typography="ud-text-sm" data-purpose="caption-more">{ninterpolate(" %(count)s more", " %(count)s more", extraLanguages.length, {
        count: extraLanguages.length
      })}</Button>;
    let t12;
    if ($[21] !== t10 || $[22] !== t11 || $[23] !== t9) {
      t12 = <div className={styles["first-row"]}>{t9}{t10}{t11}</div>;
      $[21] = t10;
      $[22] = t11;
      $[23] = t9;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    t6 = <div className={t7} data-purpose="caption">{t12}{isLocalExpanded && extraLanguages.length > 0 && <div className={styles["second-row"]} data-purpose="extra-languages">{extraLanguages.map((language_1, index_1) => renderLanguage(language_1, index_1, extraLanguages.length))}</div>}</div>;
    $[8] = captionedLanguages;
    $[9] = gettext;
    $[10] = handleExpandClick;
    $[11] = isLocalExpanded;
    $[12] = ninterpolate;
    $[13] = renderLanguage;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};